<template>
  <div id="card-vessel-documents-view" v-if="documentsList">
    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="flex items-center px-3">
            <div class="flex-grow">
              <h4>船舶書類</h4>
            </div>
            <vs-button
              class="mt-4"
              icon-pack="feather"
              icon="icon-plus"
              :color="AISEA_COLOR.BLUE"
              type="filled"
              @click="showDialog"
              >新規登録</vs-button
            >
          </div>
          <vs-divider />
        </div>
      </div>
      <div class="vx-row">
        <div
          class="vx-col w-full sm:w-1/2 lg:w-1/5 mb-base"
          v-for="document in documentsList.documents"
          :key="document.id"
        >
          <card-vessel-documents
            :data="document"
            @onDelete="onRefresh"
            @onUpdate="onRefresh"
          />
        </div>
        <div v-if="documentsList.documents.length === 0" class="m-4">
          <span class="text-lg leading-none"
            >登録されている船舶書類はありません</span
          >
        </div>
      </div>
    </vx-card>
    <dialog-add-vessel-documents
      ref="dialogAddVesselDocuments"
      @onAdd="onRefresh"
    />
  </div>
</template>

<script>
import CardVesselDocuments from "@/components/card/CardVesselDocuments";
import DialogAddVesselDocuments from "./components/DialogAddVesselDocuments";
import { ColorMixin } from "@/mixins";

import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers(
  "enterpriseVesselView"
);

export default {
  components: { CardVesselDocuments, DialogAddVesselDocuments },
  mixins: [ColorMixin],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      documentsList: state => state.documentsList
    })
  },
  methods: {
    ...mapActions(["fetchDocuments"]),

    onRefresh() {
      this.fetchDocuments(this.$route.params.vesselId);
    },

    showDialog() {
      this.$refs.dialogAddVesselDocuments.show(this.$route.params.vesselId);
    }
  },
  created() {
    this.fetchDocuments(this.$route.params.vesselId);
  }
};
</script>

<style lang="scss"></style>
